module.exports = __webpack_public_path__ + "img/vertical_7_2_8017.65328236.png";